const APPLICATION_WITHDRAW = [
    {
        sectionID: 'aecWithdraw',
        sectionName: '',
        fieldList: [
            {
                id: 'reason',
                label: '',
                type: 'longText',
                span: 12,
                textRows: 4,
                hasCharCounter: true,
                rule: { required: true, charLength: 600 }
            }
        ]
    }
];

export default APPLICATION_WITHDRAW;
